import React, { Component } from 'react';
import { TextInput, Button, Text, Scene } from 'core';
import { style, theme } from 'constants';
import { lang } from 'lang';
import * as actions from 'actions';

const styles = style({
  container: {
    flex: 1,
    backgroundColor: theme.success_color,
    alignItems: 'center'
  },
  text: {
    marginTop: 80,
    color: 'white',
    fontSize: 16,
    width: 300
  },
  field: {
    marginTop: 10,
    marginBottom: 25,
    borderColor: 'white'
  }
});

class Auth extends Component {
  state = {
    name: ''
  };

  render() {
    return (
      <Scene style={styles.container}>
        <Text style={styles.text}>{lang.FULL_NAME}</Text>
        <TextInput style={styles.field} returnKeyType={'done'} autoFocus onChangeText={name => this.setState({ name })} placeholder={lang.FULL_NAME_PH} />
        <Button color={'white'} style={styles.btn} title={lang.OK} onPress={() => actions.sendUserUpdate({ name: this.state.name })} />
      </Scene>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/components/login/name_wizard.js